/**
 * Rileva telefono/tablet e iOS in modo stabile.
 * iPadOS 13+ si presenta come Macintosh: senza maxTouchPoints finirebbe nel layout desktop.
 * Un Mac o un PC Windows restano desktop (maxTouchPoints da solo non basta).
 */
export function detectClientPlatform(nav) {
    const source = nav || (typeof navigator !== 'undefined' ? navigator : null);
    const ua = (source && source.userAgent) || '';
    const platform = (source && source.platform) || '';
    const maxTouchPoints = (source && source.maxTouchPoints) || 0;

    const isIpadDesktopMode = maxTouchPoints > 1 && (/Macintosh/i.test(ua) || platform === 'MacIntel');
    const isIos = /iPhone|iPad|iPod/i.test(ua) || isIpadDesktopMode;
    const isMobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

    return {
        isMobile: isMobileUa || isIpadDesktopMode,
        isIos,
    };
}

/** Safari su macOS. Esclude Chrome, Edge, Firefox e i telefoni/iPad. */
export function isDesktopSafari(nav) {
    const source = nav || (typeof navigator !== 'undefined' ? navigator : null);
    const ua = (source && source.userAgent) || '';
    const { isMobile, isIos } = detectClientPlatform(source);
    if (isMobile || isIos) {
        return false;
    }
    return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|Edg\/|OPR\/|Android|FxiOS|Firefox/i.test(ua);
}
